module.exports = __webpack_public_path__ + "img/sld_scb_5_t1_red.3173cac2.svg";